import * as React from "react";
const SvgDownload = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 21, height: 22, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#1F4782", d: "M21 19.16v1.89H.93v-1.89zM11.9.96V13.7l4.05-4.03 1.33 1.32-6.31 6.3-6.32-6.31 1.33-1.33 4.03 4.03V.97z" }));
export default SvgDownload;
